import { Drawer, styled } from '@mui/material';
import { forwardRef } from 'react';

import type { ChkDrawerProps } from './ChkDrawer.types';

export const ChkDrawer = forwardRef<HTMLDivElement, ChkDrawerProps>(
  (
    {
      BackdropProps,
      slotProps,
      children,
      variant = 'temporary',
      overlayMode = true,
      ...rest
    },
    ref
  ) => {
    return (
      <StyledDrawer
        ref={ref}
        overlayMode={overlayMode}
        anchor="bottom"
        elevation={0}
        variant={variant}
        ModalProps={{
          sx: {
            position: 'absolute',
            top: 'unset',
            bottom: 0,
          },
        }}
        slotProps={{
          backdrop: slotProps?.backdrop ?? BackdropProps,
        }}
        transitionDuration={0}
        SlideProps={{
          direction: 'up',
          easing: {
            enter: 'linear',
            exit: 'linear',
          },
        }}
        {...rest}
      >
        {children}
      </StyledDrawer>
    );
  }
);

const StyledDrawer = styled(Drawer, {
  shouldForwardProp: (prop) => prop !== 'handoff' && prop !== 'overlayMode',
})<{ handoff?: boolean; overlayMode: boolean }>(
  ({ theme, handoff, open, overlayMode }) => ({
    position: overlayMode ? 'absolute' : 'relative',
    bottom: 0,
    left: 0,
    width: '100%',
    overflow: 'hidden',
    pointerEvents: open ? 'all' : 'none',
    zIndex: theme.zIndex.drawer,

    '.MuiDrawer-paper': {
      position: 'static',
      background: handoff
        ? theme.tokens.bottomSheetBackgroundSurface
        : theme.tokens.bottomSheetBackgroundDefault,
      borderRadius: `${theme.borders.borderRadius2} ${theme.borders.borderRadius2} 0 0`,
      border: 'none',
    },
  })
);
